<template>
  <div
    v-if="name"
    ref="textRef"
    :class="[classes.nameContainer, classes.text, 'team-name']"
  >
    {{ name }}
  </div>
</template>
<script lang="ts">
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { computed, defineComponent, onMounted, ref } from "vue";

const useStyles = createUseStyles({
  nameContainer: {
    display: "flex",
    flexDirection: "column"
  },
  text: {
    zIndex: 1,
    fontSize: "10px",
    display: "inline-block",
    textAlign: "center",
    width: "60%",
    margin: "0 auto",
    lineHeight: "1",
    color: props => props.textColor || props.color || "#fff",
    fontFamily: props => props.fontFamily,
    fontStyle: props => props.fontStyle,
    textTransform: props => props.textTransform,
    textDecoration: props => props.textDecoration
  }
});

export default defineComponent({
  props: {
    name: {
      type: String,
      required: false,
      default: ""
    },
    textColor: {
      type: String,
      required: false,
      default: ""
    }
  },
  emits: ["banner-loaded"],
  setup(props, ctx) {
    const { teamBranding, getFontStyle } = injectBrand();
    const textRef = ref<HTMLParagraphElement | null>();
    const reactiveStyles = computed(() => ({
      textColor: props.textColor,
      ...getFontStyle(teamBranding.value?.banner?.font)
    }));

    const classes = useStyles(reactiveStyles);

    onMounted(() => {
      props.name &&
        ctx.emit("banner-loaded", { height: textRef.value?.offsetHeight });
    });

    return {
      classes,
      textRef
    };
  }
});
</script>
